import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

const store = new Vuex.Store({
    state: {
        check_log: false,
        counter: 0,
        email:null,
        first_name:null,
        id: null,
        last_name:null,
        level: null,
        level_next: null,
        points: 0,
        products_ids: [],
        products_n: [],
        products: [],
        score_needed_to_reach: null,
        thumb: null,
        token: null,
        logged: false,
        started: false
    },
    mutations: {
        decrement: state => state.counter--,
        increment: state => state.counter++,
        update (state, data) {
            state.token = data;
            state.logged = (data !== null) ? true : false;
        },
        update_started (state, data) {
            state.started = data;
        },
        update_cart (state, data) {
            state.counter = data;
        },
        update_check_log (state, data) {
            state.check_log = data;
        },
        update_cart_products (state, data) {
            if (data) {
                let index = state.products_ids.indexOf(data.id);
                if (index !== -1) {
                    state.products[index] = data;
                    state.products_n[index] = data.quantity;
                } else {
                    state.products_ids.push(data.id);
                    state.products_n.push(data.quantity);
                    state.products.push(data);
                }
            }
            else {
                state.products_ids = [];
                state.products_n = [];
                state.products = [];
            }
            let total_items = 0;
            for (let o in state.products) {
                total_items += state.products[o].quantity;
            }
            //state.counter = state.products.length;
            state.counter = total_items;
        },
        del_product_cart (state, data) {
            if (data) {
                let index = state.products_ids.indexOf(data.id);
                if (index !== -1) {
                    state.products_ids.splice(index, 1);
                    state.products_n.splice(index, 1);
                    state.products.splice(index, 1);
                    state.counter = state.products.length;
                }
            }
        },
        update_profile (state, data) {
            state.email      = data.email;
            state.id         = data.id;
            state.first_name = data.first_name;
            state.last_name  = data.last_name;
        },
        update_points (state, data) {
            if (data) {
                //console.log('aqui -> ', data);
                //state.points                = data.total_points;
                state.points                = data.redeemable_points;
                try { state.level                 = data.tier_info.current_level.title; } catch(e) { e; }
                try { state.level_next            = data.tier_info.next_level.title; } catch(e) { e; }
                try { state.score_needed_to_reach = data.tier_info.score_needed_to_reach; } catch(e) { e; }
                //state.thumb                 = data.tier_info.current_level.image_url;
            } else {
                state.points                = 0;
                state.level                 = null;
                state.level_next            = null;
                state.score_needed_to_reach = null;
            }
        }
    },
    getters: {
        counter:               state => state.counter,
        email:                 state => state.email,
        first_name:            state => state.first_name,
        id:                    state => state.id,
        last_name:             state => state.last_name,
        level:                 state => state.level,
        level_next:            state => state.level_next,
        logged:                state => state.logged,
        started:               state => state.started,
        points:                state => state.points,
        products:              state => state.products,
        products_ids:          state => state.products_ids,
        products_n:            state => state.products_n,
        score_needed_to_reach: state => state.score_needed_to_reach,
        thumb:                 state => state.thumb,
        token:                 state => state.token,
        check_log:             state => state.check_log
    },
    actions: {
        decrement: ({ commit }) => commit('decrement'),
        increment: ({ commit }) => commit('increment'),
        update: (state, data) => {
            state.commit('update', data);
        },
        update_started: (state, data) => {
            state.commit('update_started', data);
        },
        update_cart: (state, data) => {
            state.commit('update_cart', data);
        },
        update_cart_products: (state, data) => {
            state.commit('update_cart_products', data);
        },
        del_product_cart: (state, data) => {
            state.commit('del_product_cart', data);
        },
        update_profile: (state, data) => {
            state.commit('update_profile', data);
        },
        update_points: (state, data) => {
            state.commit('update_points', data);
        },
        update_check_log: (state, data) => {
            state.commit('update_check_log', data);
        }
    }
})

export { store }
